export const tabManipulate = {
    init: function(){
        const containers = [... document.querySelectorAll('[data-tabsoffer-module]')];

        containers.forEach((el)=>{
            const container = el,
                tabs = [... container.querySelectorAll('[data-taboffer]')];

            tabs.forEach((el, index)=>{
                const tab = el;

                if ( !tab.classList.contains('active') )
                    tab.tabIndex = -1;
                
                tab.addEventListener('keydown', (ev)=>{                    
                    this.onArrowDown({
                        event: ev,
                        keyCode: ev.keyCode, 
                        index: index,
                        tabs: tabs
                    });
                });
            });
        });
    },

    onArrowDown: function(object){
        let keyCode = object.keyCode,
            event = object.event,
            index = object.index,
            tabs = object.tabs,
            nextIndex;
        
        switch ( keyCode ){
            //Left Arrow
            case 37:
                nextIndex = index - 1;
                this.tabManipulate(tabs, index, nextIndex);
            break;

            //Right Arrow
            case 39:
                nextIndex = index + 1;
                this.tabManipulate(tabs, index, nextIndex);
            break;

            //Home Button
            case 36:
                nextIndex = 0;
                this.tabManipulate(tabs, index, nextIndex);
            break;

            //End Button
            case 35:
                event.preventDefault();
                nextIndex = tabs.length - 1;
                this.tabManipulate(tabs, index, nextIndex);
            break;
        }

    },

    //Checks if is first element is bigger then second 
    isBiggestThanLength(el, el2){
        return el > el2;
    },

    //Checks if is first element is less then second 
    isLessThanLength(el, el2){
        return el < el2;
    },

    //Change tab active by index
    tabManipulate: function(tabs, index, nextIndex){
        if ( this.isLessThanLength(nextIndex, 0) )
            nextIndex = tabs.length - 1;
        else if ( this.isBiggestThanLength(nextIndex, tabs.length - 1) )
            nextIndex = 0;

        tabs[index].classList.remove('active');
        tabs[index].tabIndex = -1;

        tabs[nextIndex].classList.add('active');
        tabs[nextIndex].focus();
        tabs[nextIndex].click();
        tabs[nextIndex].tabIndex = 0
    },
}